import { Autocomplete, Button, Card, Table, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import { post, Token } from '../../../Script/Session';

function TeilnehmerViewer({ data, update }) {
    function anmelden() {
        let body = {};
        body.token = Token.get();
        body.action = "anmelden";
        body.targetid = data.id;
        let response = post(body, "/aktivitäten");
        console.log(response);
        update();
    }
    useEffect(() => console.log(data), []);
    function abmelden() {
        let body = {};
        body.token = Token.get();
        body.action = "abmelden";
        let a = prompt("Bitte begründen sie ihre Abmeldung kurz");
        if (!a) {
            return;
        }
        body.reason = a;
        body.targetid = data.id;
        let response = post(body, "/aktivitäten");
        console.log(response);
        update();
    }
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        setuserlist(JSON.parse(response).result);
    }, []);
    const [userlist, setuserlist] = useState();
    const [regisother, setregisother] = useState(false);
    const [seluser, setseluser] = useState();
    function regothers() {
        if (!seluser){
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "anmelden_other";
        body.targetid = data.id;
        body.userid = seluser.id;
        let response = post(body, "/aktivitäten");
        console.log(response);
        update();
        setregisother(false);
    }
    function abmeldenothers(id){
        let body = {};
        body.token = Token.get();
        body.action = "abmelden_other";
        body.targetid = data.id;
        body.userid = id;
        let response = post(body, "/aktivitäten");
        console.log(response);
        update();
        setregisother(false);
    }
    return (
        <>
            {
                regisother && (
                    <Card>
                        <Typography>Andere Anmelden</Typography>
                        <Autocomplete value={seluser} options={userlist} getOptionLabel={(i) => i.name} onChange={(e, newv) => setseluser(newv)} />
                        <Button onClick={() => regothers()} sx={{ width: "10%" }}>Anmelden</Button>
                    </Card>
                )
            }
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Nimmt Teil</th>
                        <th>Begründung</th>
                        {
                            data.editperms && (
                                <th>Bearbeiten</th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data && data?.teilnehmer.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <td>{data?.abgemeldet.some((i) => i.id === item.id) ? "Nein" : "Ja"}</td>
                                    <td>
                                        {data?.abgemeldet.find((i) => i.id === item.id)?.reason || ""}
                                    </td>
                                    {
                                        data.editperms && !data?.abgemeldet.some((i) => i.id === item.id) &&  (
                                            <td><Button onClick={() => abmeldenothers(item.id)} color='danger'>Abmelden</Button></td>
                                        )
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
                {
                    data?.kannabmelden && (
                        <Button onClick={() => abmelden()} color='danger'>Abmelden</Button>
                    )
                }
                {
                    !data?.kannabmelden && data?.kannanmelden && (
                        <Button onClick={() => anmelden()} color="success">Anmelden</Button>
                    )
                }
                {
                    data.editperms && (
                        <Button onClick={() => setregisother(true)} sx={{ ml: 2 }}>Andere Anmelden</Button>
                    )
                }
            </Table>
        </>
    )
}

export default TeilnehmerViewer
